// extracted by mini-css-extract-plugin
export default {"navbar":"Header_navbar__gpm+q","title":"Header_title__Mk2Ff","input-box":"Header_input-box__bJ1xp"};